import React, { Component } from "react";
import { authenticate, make_request } from "../../Utils/Utils";

export default class Checkpoint extends Component {
  constructor(props) {
    super(props);
    const { level_name, edition_id } = this.props.match.params;
    this.state = {
      artifact: "",
      level_name: level_name,
      edition_id: edition_id,
      redirect_to: "/edition/"+edition_id+"/"+level_name
    };
  }

  async componentDidMount() {
    if (authenticate()) {
      const { level_name, edition_id, redirect_to } = this.state;
      let responseJson = await make_request({
        path: "checkpoint",
        method: "POST",
        body: { level_name, edition_id },
      });
      if (responseJson["status"] === "success") {
        this.setState({ artifact: responseJson["artifact"] });
      } else {
        window.location = redirect_to;
      }
    } else {
      this.props.history.push("/login");
    }
  }

  render() {
    const { artifact, redirect_to } = this.state;
    return (
      <div className="innerBody">
        <div className="container mt-2 levelpage mb-5 text-center">
          <div className="col-md-8 col-12 offset-md-2 mt-4 mb-4">
            <img
              src={artifact}
              alt="level_image"
              style={{ width: "100%", height: "430px" }}
            />
          </div>
          <div>
            <a href={redirect_to}
              className="btn btn-yellow">
              Continue
            </a>
          </div>
        </div>
      </div>
    );
  }
}
